import { useTranslation } from 'react-i18next';
import { mutedSmallStyle } from './vinExtractionStyles';
import AttemptCard from './AttemptCard';

const CarAttempts = ({ car, threshold, thresholdIsCurrent }) => {
    const { t } = useTranslation('vinExtraction');
    // E15: legacy batch, failed attempt insert, job_failed or a per-car exception → no rows, said so
    if (!car.attempts.length) return <span style={mutedSmallStyle}>{t('drawer.noAttempts')}</span>;

    const ordered = [...car.attempts].sort((a, b) => a.attemptNumber - b.attemptNumber);
    const latest = ordered[ordered.length - 1];

    return ordered.map(attempt => (
        <AttemptCard
            key={attempt.attemptNumber}
            attempt={attempt}
            latest={attempt === latest}
            highlighted={attempt === latest && car.status === 'failed'}
            threshold={threshold}
            thresholdIsCurrent={thresholdIsCurrent}
        />
    ));
};

export default CarAttempts;
